<template>
    <font-awesome-icon v-if="isStatusConfigured" :icon="icon" :class="`text-${variant}`" :style="{ 'color': color }"/>
</template>

<script>
export default {
    name: "DispatchRequestIcon",

    props: {
        status: { required: true, type: String, default: 'unknown' },
    },

    computed: {
        isStatusConfigured() {
            return !!DISPATCH_REQUEST_ICONS[this.status]
        },
        icon() {
            return DISPATCH_REQUEST_ICONS[this.status].icon
        },
        variant() {
            return DISPATCH_REQUEST_ICONS[this.status].variant
        },
        color() {
            return DISPATCH_REQUEST_ICONS[this.status].color
        }
    },
}

const DISPATCH_REQUEST_ICONS = {
    'unknown': null,
    'on-hold': {
        icon: 'pause-circle',
        variant: 'warning',
    },
    'on-hold-final': {
        icon: 'stop-circle',
        variant: 'danger',

    },
    'on-hold-final-manual': {
        icon: 'stop-circle',
        variant: 'danger',

    },
    'on-hold-released': {
        icon: 'play-circle',
        variant: 'info',

    },
    'on-hold-released-manual': {
        icon: 'play-circle',
        variant: 'info',

    },
    'to-be-requested': {
        icon: 'box-open',
        variant: 'info',
    },
    'requested': {
        icon: 'box-open',
        variant: 'primary',
    },
    'requested-externally': {
        icon: 'box-open',
        variant: 'primary',
    },
    'requested-paused': {
        icon: 'pause-circle',
        variant: 'info',
    },
    'request-confirmed': null,
    'cancel-to-be-requested': null,
    'cancel-requested': null,
    'cancelled': {
        icon: 'ban',
        variant: 'danger',
    },
    'ready-to-ship': {
        icon: 'truck',
        variant: 'primary',
    },
    'shipped': {
        icon: 'truck',
        variant: 'success',
    },
    'surplus': null,
    'unable-to-ship': {
        icon: 'exclamation-circle',
        variant: 'danger',
    },
    'unable-to-ship-final': {
        icon: 'exclamation-circle',
        variant: 'danger',
    },
    'delivered': null,
    'denied': null,
    'in-review': null,
    'requires-hold-evaluation': {
        icon: 'clock',
        variant: 'primary',
    },
    'return-announced': {
        icon: 'bullhorn',
        variant: 'info',
    },
    'return-received': {
        icon: 'sign-in-alt',
        variant: 'primary',
    },
    'waiting-for-stock': {
        icon: 'inbox',
        variant: 'secondary',
    },
    'crossdock-requested': {
        icon: 'sign-out-alt',
        variant: 'primary',
    },
    'crossdock-received': {
        icon: 'dolly-flatbed',
        variant: 'primary',
    },
    'crossdock-unable-to-ship': {
        icon: 'exclamation-circle',
        variant: 'danger',
    },
    'shipped-with-issues': {
        icon: 'far fa-frown',
        variant: 'danger',
    },
    'unable-to-assign': {
        icon: 'circle-xmark',
        variant: 'danger',
    },
    'rerouted': {
        icon: 'route',
        variant: 'dark',
    },
}
</script>
